import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import {
  CHANGE_ACCOUNT,
  CHANGE_ACCOUNT_SUCCESS,
  ChangeAccountAction,
  ChangeAccountSuccessAction,
  FETCH_AVAILABLE_ACCOUNT,
  FETCH_AVAILABLE_ACCOUNT_FAILURE,
  FetchAvailableAccountsFailureAction,
  FetchAvailableAccountsSuccessAction,
  RESET_ACCOUNT,
  ResetAccountSuccessAction,
} from "./accounts.actions";
import {
  AccountsResponse,
  CURRENT_ACCOUNT_LOCAL_STORAGE_KEY,
} from "./accounts.interface";
import { AccountsService } from "./accounts.service";
import { of } from "rxjs";
import { AuthService } from "../auth/auth.service";

@Injectable()
export class AccountsEffects {
  constructor(
    private actions$: Actions,
    private accountsService: AccountsService,
    private authService: AuthService,
  ) {}

  changeAccount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CHANGE_ACCOUNT),
      map((payload: ChangeAccountAction) => {
        window.localStorage.setItem(
          CURRENT_ACCOUNT_LOCAL_STORAGE_KEY,
          payload.payload,
        );
        return new ChangeAccountSuccessAction(payload.payload);
      }),
    ),
  );

  changeAccountSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CHANGE_ACCOUNT_SUCCESS),
        tap(() => {
          if (this.authService.idToken || this.authService.appUser) {
            void this.authService.fetchCurrent();
          }
        }),
      ),
    { dispatch: false },
  );

  resetAccount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RESET_ACCOUNT),
      map(() => new ResetAccountSuccessAction()),
    ),
  );

  fetchAvailableAccounts = createEffect(() =>
    this.actions$.pipe(
      ofType(FETCH_AVAILABLE_ACCOUNT),
      switchMap(() => {
        return this.accountsService.getAllAvailable().pipe(
          switchMap((response: AccountsResponse) => {
            return [new FetchAvailableAccountsSuccessAction(response)];
          }),
          catchError((error) =>
            of(new FetchAvailableAccountsFailureAction(error)),
          ),
        );
      }),
    ),
  );

  defaultAccountsRedirect = createEffect(() =>
    this.actions$.pipe(
      ofType(FETCH_AVAILABLE_ACCOUNT_FAILURE),
      map(() => {
        return new ChangeAccountAction(
          this.authService.appUser.availableDomains[0],
        );
      }),
    ),
  );
}
